import { render, staticRenderFns } from "./FenceManage.vue?vue&type=template&id=9683f026&scoped=true"
import script from "./FenceManage.vue?vue&type=script&lang=js"
export * from "./FenceManage.vue?vue&type=script&lang=js"
import style0 from "./FenceManage.vue?vue&type=style&index=0&id=9683f026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9683f026",
  null
  
)

export default component.exports